import { EventStatusId, IncidentId } from '@collector/sportsapi-client-legacy'

type Duration = {
  period: number
  overtime: number
}

export function getLiveDuration(duration: Duration): Duration {
  if (duration.overtime === 0) {
    return {
      ...duration,
      period: duration.period - 1,
    }
  } else if (duration.overtime > 0) {
    return {
      ...duration,
      overtime: duration.overtime - 1,
    }
  }

  return duration
}

/**
 * Get the duration of the event status based on the `incidentId`.
 */
export type GetIncidentIdDuration = (
  incidentId: IncidentId,
  numberOfPeriods: number,
) => Duration | null

/**
 * Get the duration of the event status based on the `eventStatusId`
 */
export type GetEventStatusDuration = (
  eventStatusId: EventStatusId,
  numberOfPeriods: number,
) => Duration | null

/**
 * Get the duration of based on the `incidentId`:
 * - if sending `incidentId` would change the event status, it should return the duration associated with the event new status.
 * - if sending `incidentId` would not change the event status, it should return the duration associated with the event current status.
 */
export type GetIncidentDuration = (
  incidentId: IncidentId,
  eventStatusId: EventStatusId,
  numberOfPeriods: number,
) => Duration | null

export type EventDurationConfig = {
  getEventStatusDuration: GetEventStatusDuration
  getIncidentDuration: GetIncidentDuration
}
